import { z } from "zod";

import { DASHBOARD_PERIODS } from "./DASHBOARD_PERIODS";

// Search params дашборда: `/dashboard?period=7`. Нет параметра или неверное значение —
// период по умолчанию.
export const dashboardSearchSchema = z.object({
  period: z.coerce
    .number()
    .pipe(z.union(DASHBOARD_PERIODS.map((days) => z.literal(days))))
    .optional()
    .catch(undefined),
});

export type DashboardSearch = z.infer<typeof dashboardSearchSchema>;
